import { Routes } from "@angular/router";
import { ErrorPageComponent } from "./shared/pages/error-page/error-page.component";

export const routes: Routes = [
    {
        path: "",
        pathMatch: "full",
        loadComponent: () => import("./modules/landing/landing.component").then((m) => m.LandingComponent),
    },
    {
        path: "value-added-services",
        loadChildren: () =>
            import("./modules/value-added-services/value-added-services.routes").then(
                (m) => m.VALUE_ADDED_SERVICES_ROUTES,
            ),
    },
    {
        path: "error",
        component: ErrorPageComponent,
    },
    {
        path: "**",
        redirectTo: "error",
    },
];
